import { globalCss } from '@abyss/web/tools/styled';

const GlobalStyles = globalCss({
  body: {
    backgroundColor: '$gray2',
  },
});

export {
  GlobalStyles
}